import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { WebsiteImage } from 'components/TitleDescription';
import isNil from 'utils/isNil';

const CompanyLogoSection = ({ background, logos, ...otherProps }) => {
  return (
    <SectionCompanyLogo background={background} {...otherProps}>
      <div className="section-company-logo--container">
        <div className="section-company-logo--content">
          {logos.map((logoItem, index) => {
            return (
              <div className="section-company-logo--item" key={index}>
                <div
                  className={`section-company-logo--image-wrapper section-company-logo-custom-${index}`}
                >
                  <WebsiteImage src={logoItem} />
                </div>
                {!isNil(logoItem.description) && (
                  <p className="section-company-logo--description">{logoItem.description}</p>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </SectionCompanyLogo>
  );
};

CompanyLogoSection.propTypes = {
  title: PropTypes.string,
  logos: PropTypes.array,
};

const SectionCompanyLogo = styled.div`
  background: ${props => props.background};

  .section-company-logo--container {
    padding: 98px 20px 130px;
    max-width: 1248px;
    margin: 0 auto;
    text-align: center;

    .section-company-logo--content {
      display: flex;

      .section-company-logo--item {
        padding: 40px 28px;
        width: 100%;
        border-right: 1px solid #cfd8dc;
        margin: 0 auto;

        & > p {
          font-size: 18px !important;
        }

        .section-company-logo--image-wrapper {
          margin: 0 auto;
          align-items: center;
          justify-content: center;
          width: 100px;
        }

        .section-company-logo--description {
          font-weight: 500;
          font-size: 16px;
          line-height: 150%;
          text-align: center;
          color: var(--normal-description-color);
          max-width: 316px;
          margin: 59px auto 0;
        }

        &:last-child {
          border: none;
        }
      }

      .section-company-logo-custom-0 {
        width: 260px !important;
      }
      .section-company-logo-custom-1 {
        width: 70px !important;
      }
    }
  }

  @media (max-width: 991px) {
  }

  @media (max-width: 768px) {
    .section-company-logo--container {
      padding: 48px 28px;

      .section-company-logo--content {
        .section-company-logo--item {
          padding: 30px 50px 0;

          .section-company-logo--image-wrapper {
            height: 56px;
            width: 100%;
          }

          .section-company-logo--description {
            margin-top: 24px;
          }
        }
      }
    }
  }

  @media (max-width: 576px) {
    .section-company-logo--container {
      .section-company-logo--content {
        flex-direction: column;

        .section-company-logo--item {
          border-right: none;
          border-bottom: 1px solid #cfd8dc;
          padding: 40px 0;
          max-width: 279px;
        }
      }
    }
  }
`;

export default CompanyLogoSection;
